
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/category/details",
      function () {
        return require("private-next-pages/category/details.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/category/details"])
      });
    }
  